import { Box, Collapse, Typography, useTheme } from '@mui/material';
import { important } from '../../../utils/global/helper';

interface Props {
  progress: number;
  max?: number;
  includePercentage?: boolean;
}

function ProgressBar({ progress = 0, max = 100, includePercentage }: Props) {
  const theme = useTheme();
  const percent = Math.round((Math.min(progress, max) / max) * 100);

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}>
      <Box
        position="relative"
        width="100%"
        height="16px"
        bgcolor={theme.palette.accent.main}
        overflow="hidden"
        borderRadius="10px">
        <Collapse
          orientation="horizontal"
          in={percent > 0}
          sx={{
            width: important(`${percent}%`),
            height: '16px',
            bgcolor: theme.palette.secondary.main,
            borderRadius: '10px',
          }}
        />
      </Box>
      {includePercentage && (
        <Typography
          fontFamily={theme.typography.fontFamily}
          variant="h5"
          component="p"
          color={theme.palette.secondary.main}>
          {`${percent}%`}
        </Typography>
      )}
    </Box>
  );
}

export default ProgressBar;
